import { h, Host, Component, Prop } from '@stencil/core';

@Component({
  scoped: true,
  styleUrls: {
    default: 'igws-multi-link.less',
    rtl: 'igws-multi-link.rtl.less',
    rebrand: 'igws-multi-link.less',
    rtl_rebrand: 'igws-multi-link.rtl.less',
    prime: 'igws-multi-link.less',
    rtl_prime: 'igws-multi-link.rtl.less',
    investments: 'igws-multi-link.less',
    rtl_investments: 'igws-multi-link.rtl.less',
    helpandsupport: 'igws-multi-link.less',
    rtl_helpandsupport: 'igws-multi-link.rtl.less',
    academy: 'igws-multi-link.less',
    rtl_academy: 'igws-multi-link.rtl.less',
    landingpages: 'igws-multi-link.less',
    rtl_landingpages: 'igws-multi-link.rtl.less',
    generic: 'igws-multi-link.less',
    rtl_generic: 'igws-multi-link.rtl.less',
  },
  tag: 'igws-multi-link',
})
export class MultiLinkComponent {
  /**
   * Links alignment
   */
  @Prop() alignCenter!: boolean;
  /**
   * Forces mobile styles in desktop view
   */
  @Prop() forceMobile!: boolean;

  render() {
    return (
    <Host class={{center: this.alignCenter, mobile: this.forceMobile}}>
      <slot/>
    </Host>
    );
  }
}
